export const SUPPORTS_ARRAY_PROTOTYPE_SLICE = "slice" in Array.prototype;
